import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FormControl from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/FormControl';
import Select from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Select';
import MenuItem from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/MenuItem';
import { FDIcon } from '@facet-wealth/design';
import { noop } from 'Helpers/PropTypes';
import Typography from 'Components/UI/Typography';

const useStyles = buildUseStyles('OutcomeSelector', (theme) => ({
  root: {
    // Hide the default underline completely
    '& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
    // Override default padding to pull the selected text to the left
    '& .MuiSelect-select .MuiTypography-root': {
      fontSize: '2rem',
      fontWeight: 700,
      color: theme.palette.primary.main,
      lineHeight: 1.2,
      paddingRight: '0.5rem !important', // Leave space for the chevron icon
      whiteSpace: 'normal',
    },
    // Override default padding to pull the selected text to the left
    '& .MuiSelect-select svg': {
      display: 'none', // Hide the menu item icon
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
  },

  // --- CUSTOM CHEVRON ICON STYLE ---
  customIcon: {
    position: 'absolute',
    color: theme.palette.primary.main,
    right: 0,
    top: '50%',
    // The div is larger than the typography, this centers the icon correctly
    transform: 'translateY(calc(-50% + 5px))',
    zIndex: -1, // Ensure it doesn't block clicks
  },

  // --- MENU ITEM STYLES (Inside the Blue Box) ---
  menuItemRoot: {
    padding: theme.spacing(2, 3), // Generous padding for spacing
    margin: theme.spacing(1),
    borderRadius: '8px',
    border: '1px solid transparent', // Default border. This is important so when the border is added on hover nothing shifts
    // Apply styling for the selected item within the menu
    '&$menuItemSelected': {
      border: '1px solid white',
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        border: '1px solid white', // Darker blue on hover
      },
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      border: '1px solid white', // Darker blue on hover
    },
  },
  menuItemSelected: {}, // Empty style for the selected state selector (required for `&$` syntax)
  menuTypography: {
    color: 'white',
    fontSize: '1rem',
    fontWeight: 400,
  },
}));

const OutcomeSelector = ({ options = [], selected = '', onChange = noop }) => {
  const classes = useStyles();

  return (
    <FormControl className={classes.formControl}>
      <Select
        value={selected}
        onChange={(e) => onChange(e.target.value)}
        disableUnderline
        IconComponent={() => (
          <div className={classes.customIcon}>
            <FDIcon icon={'caretDown'} color={'textSecondary'} size={'md'} />
          </div>
        )}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          // Override the default paper styles for the menu popup
          PaperProps: {
            style: {
              backgroundColor: '#007098',
              marginTop: '10px', // Small gap below the selected text
              minWidth: 300,
              borderRadius: '18px',
              boxShadow: '0px 8px 10px rgba(0, 0, 0, 0.2)',
            },
          },
        }} // Apply custom styles to the dropdown paper
        className={classes.root}
        classes={{ select: classes.select }}
      >
        {options.map((item) => (
          <MenuItem
            key={item.value}
            value={item.value}
            classes={{
              root: classes.menuItemRoot,
              selected: classes.menuItemSelected,
            }}
          >
            <FDIcon icon={item.icon} color={'white'} />
            <Typography className={classes.menuTypography}>
              {item.label}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

OutcomeSelector.propTypes = {};

export { OutcomeSelector };
